export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

/** Локальная разработка без бэкенда: REACT_APP_USE_MOCK=true */
export const USE_MOCKS = process.env.REACT_APP_USE_MOCK === 'true';

export const TOKEN_KEY = 'bypass_admin_auth_token';
export const USER_KEY = 'bypass_admin_auth_user';
export const REFRESH_TOKEN_KEY = 'bypass_admin_refresh_token';

export const UNAUTHORIZED_EVENT = 'bypass-admin:unauthorized';
